var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container flex-horizontal" },
    _vm._l(_vm.openTabs, function(tab) {
      return _c(
        "div",
        {
          key: tab.name,
          staticClass: "tab-box",
          on: {
            click: function($event) {
              return _vm.selectTab(tab)
            }
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.$tc(tab.display, 2)) + "\n  ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ece8c3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ece8c3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/TabSelection.vue
// module id = null
// module chunks = 